import { SsoService } from '@/common/api.service';
import { destroyToken, getToken, saveToken } from '@/common/jwt.service';
import {
  SSO_URL, CLIENT_ID, REDIRECT_URI, SCOPE,
} from '@/common/config';
import md5 from 'md5';
import {
  LOGIN,
  LOGOUT,
  CHECK_AUTH,
  CALLBACK,
} from '../actions.type';

import {
  SET_AUTH, SET_TOKEN, PURGE_AUTH, SET_ERROR, FETCH_START, FETCH_END,
} from '../mutations.type';

const state = {
  errors: null,
  user: null,
  isAuthenticated: !!getToken(),
  locale: 'en',
  isLoading: false,
};

const getters = {
  currentUser() {
    return state.user;
  },
  isAuthenticated() {
    return state.isAuthenticated;
  },
  isLoading() {
    return state.isLoading;
  },
  locale() {
    return state.user ? state.user.language.toLowerCase() : 'fr';
  },
};

const actions = {
  // eslint-disable-next-line consistent-return
  [LOGIN]() {
    window.location.href = `${SSO_URL}/authorize?client_id=${CLIENT_ID}&response_type=code&scope=${SCOPE}&redirect_uri=${REDIRECT_URI}`;
  },
  [CALLBACK](context, { code }) {
    context.commit(FETCH_START);
    return new Promise((resolve, reject) => {
      SsoService.getIdToken(code).then(({ data }) => {
        context.commit(SET_TOKEN, { id_token: data.id_token });
        context.dispatch(CHECK_AUTH)
          .then(() => resolve());
      }).catch((error) => {
        reject(error);
      });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [CHECK_AUTH](context) {
    context.commit(FETCH_START);
    // Token exist => verify token
    const token = getToken();
    if (token) {
      return new Promise((resolve, reject) => {
        SsoService.verifyToken(token)
          .then(({ data }) => {
            const { claims } = data;
            context.commit(SET_AUTH, { ...claims, id_token: getToken() });
            resolve();
          })
          .catch(() => {
            context.commit(PURGE_AUTH);
            reject();
          });
      });
    }
    return null;
  },
};

const mutations = {
  [FETCH_START]() {
    state.isLoading = true;
  },
  [FETCH_END]() {
    state.isLoading = false;
  },
  [SET_ERROR](states, error) {
    state.errors = error;
  },
  [SET_TOKEN](states, user) {
    saveToken(user.id_token);
  },
  // eslint-disable-next-line no-shadow
  async [SET_AUTH](states, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    state.locale = user ? user.language && user.language.toLowerCase() : 'en';

    if (state.user.login) {
      const gravatar = `https://s.gravatar.com/avatar/${md5(state.user.login.toLowerCase().trim())}?s=150&d=404`;
      state.user.initials = state.user.firstName[0] + state.user.lastName[0];
      state.user.avatarUrl = gravatar;
    }
    state.isLoading = false;
  },
  [PURGE_AUTH]() {
    // eslint-disable-next-line no-undef
    destroyToken();
    state.isAuthenticated = false;
    state.user = null;
    state.errors = {};
    state.avatar = null;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
